import { useContext, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { apiRequest } from "src/async/apiUtils";
import Preloader from "src/components/shared/LoadingAnimations/Preloader";
import { AuthContext } from "src/context/auth";
import { useUpdateSocketToken } from "src/context/SocketContext";
import { clearCookies } from "src/helpers";

const AuthenticationVerify = () => {
  const navigate = useNavigate();
  const { token } = useParams();
  const { setUser } = useContext(AuthContext);
  const updateSocketToken = useUpdateSocketToken();

  const verifyToken = async () => {
    try {
      localStorage.removeItem("email");
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      localStorage.removeItem("isSubDomain");
      clearCookies();
      setUser(null);

      const { data } = await apiRequest("get", "/portal/authentication/verify", {}, { headers: { Authorization: `Bearer ${token}` } });
      localStorage.setItem("accessToken", data.access_token);
      localStorage.setItem("refreshToken", data.refresh_token);
      localStorage.setItem("email", data.email);
      updateSocketToken(data.access_token);
      navigate(data.link);
    } catch (err) {
      navigate("/login");
    }
  };

  useEffect(() => {
    verifyToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <div className="flex h-full items-center justify-center">
      <Preloader />
    </div>
  );
};

export default AuthenticationVerify;
